import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SearchBannerComponent} from '../search-banner/search-banner.component';
import {TranslocoPipe} from '@jsverse/transloco';
import {TitleCasePipe, UpperCasePipe} from '@angular/common';

@Component({
  selector: 'app-hero-banner',
  imports: [
    SearchBannerComponent,
    TranslocoPipe,
    TitleCasePipe
  ],
  templateUrl: './hero-banner.component.html',
  styleUrl: './hero-banner.component.scss'
})
export class HeroBannerComponent {
  @Input() city: string|null = null;
  @Input() tags: string[]|null = null;
  @Output() onCityChange = new EventEmitter<string|null>();
  @Output() onTagsChange = new EventEmitter<string[]>();

  public cityChanged(city: string|null): void {
    this.onCityChange.emit(city);
  }

  public tagsChanged(tags: string[]): void {
    this.onTagsChange.emit(tags);
  }
}
